import { Button, Card, Checkbox, Col, message, Row } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import gql from 'graphql-tag';
import * as moment from 'moment';
import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router';
import { Panel } from 'src/components/Panel';
import { client } from 'src/services/api';
import styled from 'styled-components';

import { AddSaleType } from './AddSaleType';
import { AddSku } from './AddSku';

const FootBar = styled.div`
  margin-top: 20px;
  line-height: 56px;
  height: 56px;
  background: white;
  padding: 0 24px;
  text-align: right;
  box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.03);
`;

interface SkuInput {
  courseId: number;
  price: number;
  start: Date;
  end: Date;
  availableFrom: Date;
  availableUntil: Date;
  completeCourseAt: Date;
  totalStock: number;
  name: string;
  quizEndAt?: Date;
  originalPrice?: number;
}

interface GroupSaleInput {
  total: number;
  minSize: number;
  startAt: Date;
  endAt: Date;
  duration: number;
  isActive: boolean;
  isListDisplayed: boolean;
  changeGroupRule: number;
  userLimited: number;
  autoGroupRule: number;
}

export const createSkuMutation = gql`
  mutation createSku($skuInput: SkuInput!, $groupSaleInput: GroupSaleInput, $skuGroupIds: [ID]!) {
    createSku(skuInput: $skuInput, groupSaleInput: $groupSaleInput, skuGroupIds: $skuGroupIds) {
      id
      courseId
      price
    }
  }
`;

interface Props extends RouteComponentProps {
  form: WrappedFormUtils;
}
interface State {
  checked: boolean;
  saleTypeList: string[];
  isGroupSale: boolean;
}

export class StockAddToDo extends Component<Props, State> {
  children: any;
  skuChildren: any;
  constructor(props: Props) {
    super(props);
    this.state = {
      checked: true,
      isGroupSale: false,
      saleTypeList: ['common'],
    };
  }

  private variables: { skuInput: SkuInput; groupSaleInput?: GroupSaleInput; skuGroupIds: number[] };
  submitAllForm = () => {
    const {
      form: { validateFieldsAndScroll },
    } = this.props;
    validateFieldsAndScroll(async (error, values) => {
      if (!error && this.conditionValidate(values)) {
        const {
          name,
          courseId,
          price,
          totalStock,
          completeCourseAt,
          quizEndAt,
          startEndRange,
          availableDateRange,
          skuGroupIds,
          originalPrice,
        } = values;
        const [startDate, endDate] = startEndRange;
        const [availableFromDate, availableUntilDate] = availableDateRange;
        const start = moment(startDate).startOf('day').utc().toDate();
        const end = moment(endDate).endOf('day').utc().toDate();
        const availableFrom = moment(availableFromDate).startOf('day').utc().toDate();
        const availableUntil = moment(availableUntilDate).endOf('day').utc().toDate();

        const skuInput: SkuInput = {
          name,
          courseId,
          price,
          totalStock,
          start,
          end,
          availableFrom,
          availableUntil,
          completeCourseAt: moment(completeCourseAt).endOf('day').utc().toDate(),
        };
        if (quizEndAt) {
          skuInput.quizEndAt = moment(quizEndAt).endOf('day').utc().toDate();
        }
        if (originalPrice) {
          skuInput.originalPrice = originalPrice;
        }
        if (skuGroupIds && skuGroupIds.length === 0) {
          return;
        }
        this.variables = {
          skuInput,
          skuGroupIds,
        };
        if (this.state.isGroupSale) {
          const {
            total,
            minSize,
            userLimited,
            autoGroupRule,
            changeGroupRule,
            startAt,
            endAt,
            duration,
            isActive,
            isListDisplayed,
          } = values;

          const groupSaleInput = {
            total,
            minSize,
            userLimited,
            autoGroupRule,
            changeGroupRule,
            duration,
            isActive,
            isListDisplayed,
            endAt: moment(endAt).endOf('day').utc().toDate(),
            startAt: moment(startAt).startOf('day').utc().toDate(),
          };
          this.variables = {
            skuInput,
            groupSaleInput,
            skuGroupIds,
          };
        }
        await client
          .mutate({
            mutation: createSkuMutation,
            variables: this.variables,
          })
          .then(res => {
            if (res.data && res.data.createSku) {
              message.success('操作成功！');
              this.props.history.goBack();
            }
          })
          .catch(error => {
            const [err] = error.graphQLErrors;
            message.error(err.message);
          });
      }
    });
  };

  conditionValidate = (values: {
    availableDateRange: Date[];
    startEndRange: Date[];
    completeCourseAt: string;
    quizEndAt: string;
    startAt: string;
    endAt: string;
  }) => {
    const { availableDateRange, startEndRange, completeCourseAt, quizEndAt, startAt, endAt } = values;
    const [availableDateRangeFrom, availableDateRangeTo] = availableDateRange; // 售卖时间
    const [startEndRangeFrom, startEndRangeTo] = startEndRange; // 有效期

    if (moment(startEndRangeFrom).valueOf() === moment(startEndRangeTo).valueOf()) {
      message.error('课程有效期开始时间应小于结束时间！');
      return false;
    }
    if (moment(availableDateRangeFrom).valueOf() > moment(startEndRangeFrom).valueOf()) {
      message.error('售卖时间应在开课之前！');
      return false;
    }
    if (moment(completeCourseAt).valueOf() < moment(availableDateRangeFrom).valueOf()) {
      message.error('结课时间需在开课之后！');
      return false;
    }
    if (quizEndAt) {
      if (moment(quizEndAt).valueOf() < moment(availableDateRangeTo).valueOf()) {
        message.error('测评截止时间需在售卖结束之后！');
        return false;
      }
    }
    if (this.state.isGroupSale) {
      if (moment(startAt).valueOf() >= moment(endAt).valueOf()) {
        message.error('拼团开始时间不能大于拼团结束时间');
        return false;
      }
    }
    return true;
  };

  onSelectSaleTypeChange = (checkedList: string[]) => {
    if (checkedList.indexOf('saleGroup') > -1) {
      this.setState({ isGroupSale: true });
    } else {
      this.setState({ isGroupSale: false });
    }
    this.setState({ saleTypeList: checkedList });
  };

  render() {
    return (
      <>
        <Card title="基础配置">
          <AddSku form={this.props.form} />
        </Card>

        <Panel style={{ marginTop: '10px', padding: '20px' }}>
          <Row>
            <Col span={2}>
              <span>售卖形式</span>
            </Col>
            <Col span={20}>
              <Checkbox.Group
                style={{ width: '100%' }}
                value={this.state.saleTypeList}
                onChange={this.onSelectSaleTypeChange}
              >
                <Checkbox value="common" disabled>
                  正常售卖
                </Checkbox>
                <Checkbox value="saleGroup">团购</Checkbox>
              </Checkbox.Group>
            </Col>
          </Row>
        </Panel>
        <>
          {this.state.isGroupSale && (
            <Card>
              <AddSaleType form={this.props.form} />
            </Card>
          )}
        </>

        <div className="footerbar">
          <FootBar>
            <Button onClick={() => this.props.history.goBack()} style={{ marginRight: 5 }}>
              返回
            </Button>
            <Button type="primary" onClick={this.submitAllForm}>
              提交
            </Button>
          </FootBar>
        </div>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/stock/StockAddToDo.tsx